function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-.967-3.281-2.124-4.438a.352.352,0,0,0-.5,0L-3.765-3.3-3.779,0h7.5V-4.219L2.095-5.845a.352.352,0,0,0-.5,0ZM1.846-4.767l.937.937V-.937H-2.839l.009-1.969.457-.457L-.967-1.957ZM-1.9-5.625A1.877,1.877,0,0,0-.029-7.5,1.877,1.877,0,0,0-1.9-9.375,1.877,1.877,0,0,0-3.779-7.5,1.877,1.877,0,0,0-1.9-5.625Zm0-2.812A.94.94,0,0,1-.967-7.5a.94.94,0,0,1-.937.937A.94.94,0,0,1-2.842-7.5.94.94,0,0,1-1.9-8.437Zm7.116-1.819L2.754-12.715a1.406,1.406,0,0,0-.993-.413H-4.219a1.411,1.411,0,0,0-1.406,1.409V.469A1.407,1.407,0,0,0-4.219,1.875H4.219A1.407,1.407,0,0,0,5.625.469V-9.261A1.413,1.413,0,0,0,5.212-10.257ZM1.875-12.173a.461.461,0,0,1,.217.123L4.55-9.592a.461.461,0,0,1,.123.217h-2.8ZM4.687.469a.47.47,0,0,1-.469.469H-4.219A.47.47,0,0,1-4.688.469V-11.719a.47.47,0,0,1,.469-.469H.937v3.047a.7.7,0,0,0,.7.7H4.687Z",
  transform: "translate(5.625 13.128)",
  opacity: 0.871
});

var SvgIconSide05 = function SvgIconSide05(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.25,
    height: 15.003,
    viewBox: "0 0 11.25 15.003",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSide05, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-side-05.c1513307.svg";
export { ForwardRef as ReactComponent };